import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import SignIn from './SignIn';

export default function AuthRedirect() {
  const { currentUser, loading } = useAuth();
  
  // If auth is still loading, show nothing
  if (loading) {
    return null;
  }
  
  // If user is authenticated, redirect to homepage
  if (currentUser) {
    return <Navigate to="/homepage" replace />;
  }
  
  // If user is not authenticated, show sign-in page
  return <SignIn />;
}
